import axios from "@/axios";
import Util from "@/util/util";

export const namespaced = true

export const state = {
    allTransactions: [],
    transaction: {
    },
    paginatedTransactions: [],
    allTransactionsForExporting: []
}

export const getters = {
    allTransactions: (state) => state.allTransactions,
    paginatedTransactions: (state) => state.paginatedTransactions,
    transaction: state => state.transaction,
    allTransactionsForExporting: (state) => state.allTransactionsForExporting,
}

export const mutations = {
    SET_TRANSACTIONS: (state, resp) => (state.allTransactions = resp.data),
    SET_PAGINATED_TRANSACTIONS: (state, resp) => (state.paginatedTransactions = resp.data),
    SET_TRANSACTION: (state, resp) => (state.transaction = resp.data),
    SET_ALL_TRANSACTIONS_FOR_EXPORTING: (state, resp) => (state.allTransactionsForExporting = resp.data),
}

export const actions = {

    async getTransactions({ commit }) {
        commit('SET_TRANSACTIONS', await axios.get("/api/admintransactions/"))
    },
    async getServiceTransactions({ commit }) {
        commit('SET_TRANSACTIONS', await axios.get("/api/admintransactions/transactions/service/"))
    },
    async getPaginatedTransactions({ commit }, pageInfo) {
        commit('SET_PAGINATED_TRANSACTIONS', await axios.get(`/api/admintransactions/transactions/${pageInfo.pageNumber}/${pageInfo.pageCount}/${pageInfo.searchText}`))
    },
    async getPaginatedServiceTransactions({ commit }, pageInfo) {
        // sending showMore parameter to the API call for PM1 service transactions
        const showMoreParam = pageInfo.showMore !== undefined ? `?showMore=${pageInfo.showMore}` : '?showMore=false';
        
        // Search text - if empty, use endpoint without search text
        let apiUrl;
        if (pageInfo.searchText && pageInfo.searchText.trim() !== '') {
            apiUrl = `/api/admintransactions/transactions/service/${pageInfo.pageNumber}/${pageInfo.pageCount}/${pageInfo.searchText}${showMoreParam}`;
        } else {
            apiUrl = `/api/admintransactions/transactions/service/${pageInfo.pageNumber}/${pageInfo.pageCount}${showMoreParam}`;
        }
        
        commit('SET_PAGINATED_TRANSACTIONS', await axios.get(apiUrl))
    },
    async getAllTransactionsForExporting({ commit }, searchText) {
        if (searchText == null || searchText == "") {
            commit(
                "SET_ALL_TRANSACTIONS_FOR_EXPORTING",
                await axios.get(`/api/admintransactions/transactions/`)
            );
        }
        else {
            commit(
                "SET_ALL_TRANSACTIONS_FOR_EXPORTING",
                await axios.get(`/api/admintransactions/transactions/${searchText}`)
            );
        }
    },
    async revertTransactionToSubmittedStatus({ commit }, apiParameters) {
        await axios.post(`/api/admintransactions/revert/`, apiParameters)
    },
    async getTransaction({ state, commit }, id) {
        commit('SET_TRANSACTION', await axios.get("/api/admintransactions/" + id));
        
    },

    async updateTransaction({ commit, state }) {
        await axios.post("/api/admintransactions/", state.transaction);
        commit("SET_TRANSACTION", state.transaction);
    },

    async deleteTransaction({ data }, id) {
        return await axios.delete(`/api/admintransactions/delete/${id}`)
            .then(({ data }) => {
                dispatch("getTransactions");
            });
    },

    async cancelTransaction({ data }, id) {
        return await axios.post(`/api/admintransactions/cancel/${id}`);
    },


}
